import React, { useRef ,useEffect} from 'react';
import useSharedDocHeader from "./DocHeaderHook";
import NewsItem from './NewsItem';
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import MainBPTheme from './MainBreakpoints';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import {  useQuery } from 'react-query';


const newsItemsQuery = () => ({
  queryKey: ['newsItems'],
  queryFn: async () => fetch('/data/newsItems.json'
  ,{
    headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(res =>
    res.json()
  ),option:{staleTime:1000*60*5}
})

export const loader =
  (queryClient) =>
  async ({ }) => {
    const query = newsItemsQuery();
    // ⬇️ return data or fetch it
    return (
      queryClient.getQueryData(query.queryKey) ??
      (await queryClient.fetchQuery(query))
    )
  }


export default function NewsItems() {
  const {doSetTitleKey,doSetMetaDescKey,doSetRouterId} = useSharedDocHeader();

  const { isLoading, isSuccess,error, data } = useQuery(newsItemsQuery());

  useEffect(() => {
    doSetTitleKey("common:LABEL_CURRENT");
    doSetMetaDescKey("common:LABEL_DESC_NEWS");
    doSetRouterId("/NewsItems");
  }, []);

  if (isLoading) return 'Loading...'

  if (error) return 'An error has occurred: ' + error.message


  if (isSuccess){
    return (
      <ThemeProvider theme={MainBPTheme}>
        <Grid2 height="100%" width="100%" container flex={1} direction={'column'} sx={{mt:6,pt:4,alignItems:'center',  bgcolor: 'background.paper' }}>
          <Box sx={{pt:0,  bgcolor: 'background.paper' }}>
            {data.map((item, index) => (
              <NewsItem key={index} item={item}/>
            ))}
          </Box>
        </Grid2>
      </ThemeProvider>
    )
  }
}